module.exports = __webpack_public_path__ + "media/stylesheets/images/media/banner_belcy-5cf201bc361d484102643201a25fd033.jpg";